import PropTypes from "prop-types";
import React from "react";

export default function SidebarTray({ children }) {
  return (
    <div
      css={{
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",

        width: "auto",
        height: 40,
      }}
    >
      {children}
    </div>
  );
}

SidebarTray.propTypes = {
  children: PropTypes.any.isRequired,
};
